export default __webpack_public_path__ + "static/media/BOOSABOK_P.734fd933.png";